//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Cookies from "../../helpers/CookiesHelper";
export default {
  name: "PopupContainer",
  props: ["formid"],
  data: function() {
    return {
      isVisible: false,
      timeout: 35
    };
  },

  mounted() {
    let _state = this;

    if (Cookies.getCookie("popupSeen") !== "true") {
      setTimeout(function() {
        _state.isVisible = true;
        window.ga("send", "event", "Folder Reklamowy", "Poup Aktywowany");
      }, _state.timeout * 1000);
    }
  },

  updated() {
    let form = document.querySelector(`.PopupContainer__info form.wpcf7-form`);
    wpcf7.init(form);
    jQuery(".PopupContainer__info form.wpcf7-form").each(function() {
      $(this)
        .find("img.ajax-loader")
        .last()
        .remove();
    });
  },

  methods: {
    handlePopupClose() {
      this.isVisible = false;
      Cookies.setCookie("popupSeen", "true", 4);
    }
  }
};



// WEBPACK FOOTER //
// ./scripts/vue/components/PopupContainer.vue